var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-aggregate-view__photo"},[_c('v-img',{attrs:{"src":_vm.photoData.photo_object.photo.url,"max-width":_vm.maxWidth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }